import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import Store from "./store/store";
import { I18nextProvider } from 'react-i18next';
import i18n from './language/index'
import ComingSoonPage from './ComingSoonPage';
// import {UserProvider} from './firebase/UserProvider'
ReactDOM.render(
  <Provider store={Store}>
    <I18nextProvider i18n={i18n}>
      {/* <UserProvider> */}
      <BrowserRouter>
        {/* <App /> */}
        <ComingSoonPage />
      </BrowserRouter>
      {/* </UserProvider> */}
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
